let auth = localStorage.getItem('auth')
auth = auth ? JSON.parse(auth) : {}

let children = []

// Cria as rotas de acordo com o retorno do BACKEND
if (auth.acesso && auth.acesso.modulos) {
  auth.acesso.modulos.forEach(modulo => {
    modulo.telas.forEach(tela => {
      let path = tela.web_url.replace('/', '')
      children.push({
        path: path,
        name: path,
        component: () => import(`@/views/default/${path}/index.vue`),
        meta: { title: `${modulo.descricao} ${tela.descricao}`, icon: `fas fa-${tela.icone}`, requireAuth: true, tela: tela.identificacao }
      })
    })
  })

  // Rota de Edição de Relatório
  children.push({
    path: 'edita-relatorio',
    name: 'Editar Relatório',
    component: () => import('@/views/default/edita-relatorio/index.vue'),
    meta: { title: 'Editar Relatório', icon: 'fas fa-list', requireAuth: true, tela: 'acesso_relatorio' }
  })

  // ROTA de TEST
  children.push({
    path: 'teste',
    name: 'teste',
    component: () => import('@/views/default/teste/index.vue'),
    meta: { title: 'Teste', requireAuth: true }
  })
}

export default {
  path: '/',
  name: 'default',
  component: () => import('@/views/default/index.vue'),
  meta: { requireAuth: true },
  children
}
